const MOBILE_MEDIA_QUERY = '(max-width: 749px)';

const sortByInitialOrder = (elements) =>
  elements.sort(
    (a, b) =>
      parseInt(a.dataset.initialOrder || '0', 10) - parseInt(b.dataset.initialOrder || '0', 10)
  );

const resetSliders = (gallery) => {
  gallery.querySelectorAll('slider-component').forEach((component) => {
    if (component.slider) {
      component.slider.scrollTo({ left: 0 });
    }
    component.resetPages?.();
    component.update?.();
  });
};

const setActiveSlide = (gallery, activeSlide) => {
  if (!activeSlide) return;

  const mediaList = gallery.querySelector('.product__media-list');
  if (!mediaList) return;

  const targetId = activeSlide.dataset.mediaId;
  if (!targetId) return;

  mediaList.querySelectorAll('.product__media-item').forEach((item) => {
    item.classList.toggle('is-active', item === activeSlide);
  });

  const thumbnails = gallery.querySelectorAll('.thumbnail-list__item');
  thumbnails.forEach((thumbnail) => {
    const button = thumbnail.querySelector('button');
    if (!button) return;
    if (thumbnail.dataset.target === targetId) {
      button.setAttribute('aria-current', 'true');
    } else {
      button.removeAttribute('aria-current');
    }
  });
};

const setupGallery = (gallery) => {
  if (gallery.__mobileOrderState) {
    gallery.__mobileOrderState.apply();
    return;
  }

  const state = {
    mql: window.matchMedia(MOBILE_MEDIA_QUERY),
    mode: null,
  };

  const getMediaList = () => gallery.querySelector('.product__media-list');
  const getThumbnailList = () => gallery.querySelector('.thumbnail-list');

  const applyDesktopOrder = () => {
    const mediaList = getMediaList();
    if (mediaList) {
      const slides = sortByInitialOrder(
        Array.from(mediaList.querySelectorAll('.product__media-item[data-media-id]'))
      );
      slides.forEach((slide) => mediaList.appendChild(slide));
      setActiveSlide(gallery, slides[0]);
    }

    const thumbnailList = getThumbnailList();
    if (thumbnailList) {
      const thumbnails = sortByInitialOrder(Array.from(thumbnailList.children));
      thumbnails.forEach((item) => thumbnailList.appendChild(item));
    }

    resetSliders(gallery);
    state.mode = 'desktop';
  };

  const applyMobileOrder = () => {
    const mediaList = getMediaList();
    if (!mediaList) {
      state.mode = 'desktop';
      return;
    }

    const slides = sortByInitialOrder(
      Array.from(mediaList.querySelectorAll('.product__media-item[data-media-id]'))
    );

    if (slides.length < 2) {
      setActiveSlide(gallery, slides[0] || null);
      resetSliders(gallery);
      state.mode = 'mobile';
      return;
    }

    const firstSlide = slides[0];
    const secondSlide = slides[1];

    if (secondSlide) {
      mediaList.insertBefore(secondSlide, mediaList.firstElementChild);
      setActiveSlide(gallery, secondSlide);
    }

    const thumbnailList = getThumbnailList();
    if (thumbnailList) {
      const thumbnails = sortByInitialOrder(Array.from(thumbnailList.children));
      const secondThumbnail = thumbnails[1];
      if (secondThumbnail) {
        thumbnailList.insertBefore(secondThumbnail, thumbnailList.firstElementChild);
      }
    }

    resetSliders(gallery);
    state.mode = 'mobile';
  };

  const applyMode = () => {
    if (state.mql.matches) {
      if (state.mode !== 'mobile') {
        applyMobileOrder();
      }
    } else if (state.mode !== 'desktop') {
      applyDesktopOrder();
    }
  };

  const handleChange = () => {
    applyMode();
  };

  if (state.mql.addEventListener) {
    state.mql.addEventListener('change', handleChange);
  } else {
    state.mql.addListener(handleChange);
  }

  state.apply = applyMode;
  state.cleanup = () => {
    if (state.mql.removeEventListener) {
      state.mql.removeEventListener('change', handleChange);
    } else {
      state.mql.removeListener(handleChange);
    }
  };

  gallery.__mobileOrderState = state;
  applyMode();
};

const initMobileGalleryOrdering = (root = document) => {
  root.querySelectorAll('media-gallery').forEach((gallery) => setupGallery(gallery));
};

document.addEventListener('DOMContentLoaded', () => initMobileGalleryOrdering());
document.addEventListener('product-info:loaded', (event) => initMobileGalleryOrdering(event.target));
document.addEventListener('shopify:section:load', (event) => initMobileGalleryOrdering(event.target));

document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('media-gallery').forEach((gallery) => {
    const state = gallery.__mobileOrderState;
    if (!state) return;
    state.cleanup?.();
    gallery.__mobileOrderState = undefined;
  });
});
